import React from 'react';
import {removeHTML} from '../../framework/utilities';

export default function FeaturedList({ pastContestArticles }) {
  return (
    <>
      {pastContestArticles.length > 0 &&
        <>
          <div data-card-size="large" className="grid card__grid">
            {pastContestArticles && pastContestArticles.map((article) => (
              <div key={article.id} className="grid__col-lg-6 grid__col-xs-12">
                <article className="card">
                  <a href={article.url}>
                    <img
                      src={(article.image['card-large']) ? article.image['card-large'] : article.image}
                      className="card__media"
                      alt={removeHTML(article.title)}
                    />
                    <section className="card__body card__body--large">
                        <p className="card__category">{article.kicker}</p>
                        <h4 className="card__title" dangerouslySetInnerHTML={{__html: article.title}} />
                        <p className="card__description" dangerouslySetInnerHTML={{__html: article.subheader}} />
                    </section>
                  </a>
                  <hr className="card__hr"/>
                </article>
              </div>
            ))}
          </div>
          <hr className="section__hr" />
        </>
      }
    </>
  );
}
